import { Injectable } from '@angular/core';
import { IdleDeadline } from 'requestidlecallback';

import { IdleCallbackService } from './idle-callback.service';
import { Performance } from './performance.service';

/**
 * This class is used during automated tests where requestIdleCallback takes
 * too much time and/or is flakey, thus unable to run without breaking tests.
 */
@Injectable()
export class ShimIdleCallbackService implements IdleCallbackService<ReturnType<typeof setTimeout>> {
    // Shim from: https://developers.google.com/web/updates/2015/08/using-requestidlecallback#checking_for_requestidlecallback
    public runWhenIdle(callback: (deadline?: IdleDeadline) => void): ReturnType<typeof setTimeout> {
        const start = Performance.now();
        return setTimeout(() => {
            callback({
                didTimeout: false,
                timeRemaining: () => Math.max(0, 50 - (Performance.now() - start))
            });
        }, 1);
    }

    public cancelIdleCallback(handle: ReturnType<typeof setTimeout>): void {
        clearTimeout(handle);
    }
}
